<error-panel [error]="error"></error-panel>
<mat-progress-bar *ngIf="loading"></mat-progress-bar>

<div *ngIf="!loading">
  <div class="alert alert-danger">
    <div class="mb-4">
      <b>WARNING</b>: You are about to delete the entity below.
      Please review its details carefully, since this operation cannot be undone, once you click the
      <i>Confirm Deletion</i> button.
    </div>
    <session-preview [hideActions]="true"></session-preview>
  </div>
  <actions-container [ngClass]="'mb-4'">
    <back-button></back-button>
    <button mat-raised-button color="warn" (click)="confirmDelete()">
      Confirm Deletion
    </button>
  </actions-container>
</div>
